<template>
  <v-layout warp row justify-center>
    <v-dialog v-model="chatdialog_image" @keydown.esc="close_pic()" @keydown.right="keycodeRight(model_index)" @keydown.left="keycodeLeft(model_index)" fullscreen>
      <v-card style="background-color: rgba(0, 0, 0, 0.9);">
        <v-layout row wrap style="height: 100vh;" v-if="$vuetify.breakpoint.height > 500 && $vuetify.breakpoint.width > 600">
          <v-layout row justify-center align-center>
            <v-flex grow pa-1 style="height: 100vh;">
              <v-btn fab dark small class="CloseIcon" @click="close_pic()"><v-icon>close</v-icon></v-btn>
              <v-layout row wrap align-center justify-center fill-height>
                <v-flex v-if="!progress">
                  <v-carousel
                    v-model="model_index"
                    hide-delimiters
                    :cycle="cycle"
                    :prev-icon="prevArrow"
                    :next-icon="nextArrow"
                    >
                    <v-carousel-item
                      v-for="(item, indexs) in get_data"
                      :key="indexs"
                      :src="item.message"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                    >
                    </v-carousel-item>
                  </v-carousel>
                </v-flex>
                <v-flex dark tile flat v-else>
                  <v-layout row wrap align-center justify-center style="height: 500px;">
                    <v-progress-circular size="50" color="white" :indeterminate="progress"></v-progress-circular>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 shrink pa-1 justify-center align-center style="background-color:white; height: 100vh;">
              <v-layout style="margin-top: 1.5em; margin-left: 1em; ">
                <v-flex xs3 sm3 md3 lg2 xl2  style=" margin-right: 20px;">
                  <v-avatar size="50" v-if="$vuetify.breakpoint.smOnly" class="user-photo">
                    <img v-if="picSend" :src="picSend" class="alligator-turtle">
                    <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                  </v-avatar>
                  <v-avatar size="50" v-if="$vuetify.breakpoint.mdOnly">
                    <img v-if="picSend" :src="picSend" class="alligator-turtle">
                    <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                  </v-avatar>
                  <v-avatar size="50" v-if="$vuetify.breakpoint.lgAndUp" >
                    <img v-if="picSend" :src="picSend" class="alligator-turtle">
                    <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                  </v-avatar>
                </v-flex>
                <v-flex xs8 style="margin-top: 0.3em;"  v-if="$vuetify.breakpoint.mdAndDown">
                    <h4 class="web" style="margin-right:3%;">{{nicknameSend}}</h4>
                    <p style="color: #383838; font-size: 11px; margin-top: 0.5em;">วันที่ส่ง&nbsp;{{datethai(timeSend)}} &nbsp;<v-icon style="font-size:13px !important; color: #383838 !important;">schedule</v-icon> {{ timethai(timeSend) }} น.</p>
                </v-flex>
                <v-flex xs8 style="margin-top: 0.3em;" v-else-if="$vuetify.breakpoint.lgOnly">
                    <h4 class="web" style="margin-right:3%;">{{nicknameSend}}</h4>
                    <p style="color: #383838; font-size: 11px; margin-top: 0.5em;">วันที่ส่ง&nbsp;{{datethai(timeSend)}} &nbsp;<v-icon style="font-size:13px !important; color: #383838 !important;">schedule</v-icon> {{ timethai(timeSend) }} น.</p>
                </v-flex>
                <v-flex xs8 style="margin-top: 0.3em;" v-else-if="$vuetify.breakpoint.xlOnly">
                    <h4 class="web" style="margin-right:3%;">{{nicknameSend}}</h4>
                    <p style="color: #383838; font-size: 11px; margin-top: 0.5em;">วันที่ส่ง&nbsp;{{datethai(timeSend)}} &nbsp;<v-icon style="font-size:13px !important; color: #383838 !important;">schedule</v-icon> {{ timethai(timeSend) }} น.</p>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3 md3 lg3 xl3>
                </v-flex>
                <v-flex xs9 sm9 md9 xl9 lg9 class="ml-10 mt-2">
                  <v-btn small class="buttonsubmit" @click="loadpic(filenameSend)" :loading="loading" :disabled="loading">
                    <v-icon>file_download</v-icon>&nbsp; บันทึก
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-divider class="mt-3 mr-2 ml-2"></v-divider>
            </v-flex>
          </v-layout>
        </v-layout>

        <v-layout row wrap style="height: 50vh;" v-if="$vuetify.breakpoint.height > 500 && $vuetify.breakpoint.width < 600">
          <v-flex xs12>
            <v-btn style="padding-top: 1em;" dark flat icon class="CloseIcon" @click="close_pic()"><v-icon>close</v-icon></v-btn>
            <v-layout style="padding-top: 5em; padding-left: 0.5em;">
              <v-flex xs1 sm1 md1></v-flex>
              <v-flex xs9 sm9 md9 style="padding-top: 0.8em;">
                <h4 class="mobile" style="padding-right:8%;">{{nicknameSend}}</h4>
              </v-flex>
              <v-flex xs2 sm2 md2>
                <v-btn flat icon dark @click="loadpic(filenameSend)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center style="margin-top: 2em;">
              <v-flex v-if="!progress">
                <v-carousel
                  height="300"
                  v-model="model_index"
                  hide-delimiters
                  :cycle="cycle"
                  :prev-icon="prevArrow"
                  :next-icon="nextArrow"
                  >
                  <v-carousel-item
                    v-for="(item, indexs) in get_data"
                    :key="indexs"
                    :src="item.message"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  >
                  </v-carousel-item>
                </v-carousel>
              </v-flex>
              <v-flex dark tile flat v-else>
                <v-layout row wrap align-center justify-center style="height: 500px;">
                  <v-progress-circular size="50" color="white" :indeterminate="progress"></v-progress-circular>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs12 justify-center align-center style="background-color: rgba(0, 0, 0, 0.9);">
            <v-layout style="margin-top: 1.5em; margin-left: 1.5em; ">
              <v-flex xs10 sm10 md10 style="margin-top: 0.8em;">
                <h4 class="mobile" style="margin-right:8%;">{{nicknameSend}}</h4>
              </v-flex>
              <v-flex xs2 sm2 md2>
                <v-btn flat icon dark @click="loadpic(filenameSend)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex> -->
        </v-layout>

        <v-layout row wrap style="height: 100vh;" v-if="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.height < 500">
          <v-flex xs12>
            <v-btn fab dark small class="CloseIcon" @click="close_pic()"><v-icon>close</v-icon></v-btn>
            <v-layout style="padding-top: 5em;">
              <v-flex xs6 sm6 style="padding-left: 2em; padding-top: 0.8em;">
                <h4 class="mobile">{{nicknameSend}}</h4>
              </v-flex>
              <v-flex xs2 sm2 style="padding-left: 6em;">
                <v-btn flat icon dark @click="loadpic(filenameSend)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center style="padding-top: 1em;">
              <v-flex justify-center align-center v-if="!progress">
                <v-carousel
                  height="180"
                  v-model="model_index"
                  hide-delimiters
                  :cycle="cycle"
                  :prev-icon="prevArrow"
                  :next-icon="nextArrow"
                  >
                    <v-carousel-item
                      v-for="(item, indexs) in get_data"
                      :key="indexs"
                      :src="item.message"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                    >
                    </v-carousel-item>
                </v-carousel>
              </v-flex>
              <v-flex style="background-color: rgba(0, 0, 0, 0.9);" dark tile flat v-else>
                <v-layout row wrap align-center justify-center style="height: 500px;">
                  <v-progress-circular size="50" color="white" :indeterminate="progress"></v-progress-circular>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex justify-center align-center style="background-color: rgba(0, 0, 0, 0.9); height: 100vh;">
            <v-layout style="padding-top: 14em;">
              <v-flex xs9 sm9 style="padding-left: 1em; margin-top: 0.8em;">
                <h4 class="mobile">{{nicknameSend}}</h4>
              </v-flex>
              <v-flex xs2 sm2>
                <v-btn flat icon dark @click="loadpic(filenameSend)" :loading="loading" :disabled="loading">
                  <v-icon>file_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex> -->
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { Momenttime } from '@/services'
var _ = require('lodash')
export default {
  props: {
    infor_image: {},
    chatdialog_image: Boolean
    // token_image: String,
    // time_send: String
  },
  data () {
    return {
      model_index: 0,
      prevArrow: 'arrow_back_ios',
      nextArrow: 'arrow_forward_ios',
      listimageinroom: [],
      tokenuser: '',
      tokenroom: '',
      cycle: false,
      loading: false,
      timeSend: '',
      dateSend: '',
      nicknameSend: '',
      filenameSend: '',
      picSend: '',
      typeuser: '',
      pathSend: '',
      get_data: [],
      index: '',
      check_token: '',
      tokenimage: '',
      timeSend_dateSend: '',
      checkShowimage: [],
      checkTimestamp: '',
      progress: false
    }
  },
  watch: {
    model_index () {
      // console.log(this.model_index)
      // console.log(this.get_data.length)
      this.nicknameSend = this.get_data[this.model_index].nickname
      this.timeSend = this.get_data[this.model_index].timestamp
      this.filenameSend = this.get_data[this.model_index].file_name
      this.pathSend = this.get_data[this.model_index].message
      if (this.get_data[this.model_index].profilepicture === undefined) {
        this.picSend = this.get_data[this.model_index].path_pic
      } else {
        this.picSend = this.get_data[this.model_index].profilepicture
      }
      if (this.get_data.length === this.model_index + 1) {
        this.get_image_next(this.get_data[this.model_index].tokenmessage)
      } else if (this.model_index === 0) {
        this.get_image_pre(this.get_data[this.model_index].tokenmessage)
      } else {
        // console.log(this.model_index)
        this.nextArrow = 'arrow_forward_ios'
        this.prevArrow = 'arrow_back_ios'
      }
    },
    chatdialog_image () {
      if (this.chatdialog_image) {
        // console.log(this.infor_image)
        this.nicknameSend = this.infor_image.nickname
        this.picSend = this.infor_image.path_pic
        this.timeSend = this.infor_image.timestamp
        this.tokenuser = this.$route.params.id
        this.tokenroom = this.$route.params.roomid
        this.getimage_frist(this.infor_image)
      }
    }
  },
  methods: {
    keycodeRight (index) {
      let right = event.keyCode
      if (right === 39) {
        if (this.model_index !== this.get_data.length - 1) {
          index++
          this.model_index = index
        }
      } else {
        console.log('error')
      }
    },
    keycodeLeft (index) {
      let left = event.keyCode
      if (left === 37) {
        if (this.model_index !== 0) {
          index--
          this.model_index = index
        }
      } else {
        console.log('error')
      }
    },
    get_image_pre (tokenmessage) {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_PUB + '/back_image', { tokenuser: this.tokenuser, tokenroom: this.tokenroom, tokenmessage: tokenmessage }).then((response) => {
        // console.log(response.data.data)
        this.progress = false
        if (response.data.data.length !== 0) {
          this.prevArrow = 'arrow_back_ios'
          var imageback = response.data.data.reverse()
          // console.log(imageback)
          this.get_data.unshift.apply(this.get_data, imageback)
          this.get_data = _.orderBy(this.get_data, 'timestamp')
          // console.log(this.get_data)
          this.model_index = _.findIndex(this.get_data, function (o) { return o.tokenmessage === tokenmessage })
          // console.log(this.model_index)
          // console.log(this.get_data)
        } else {
          this.prevArrow = ''
        }
      })
    },
    get_image_next (tokenmessage) {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_PUB + '/next_image', { tokenuser: this.tokenuser, tokenroom: this.tokenroom, tokenmessage: tokenmessage }).then((response) => {
        // console.log(response.data.data)
        this.progress = false
        if (response.data.data.length !== 0) {
          this.nextArrow = 'arrow_forward_ios'
          var imagenext = response.data.data.reverse()
          // console.log(imagenext)
          this.get_data.push.apply(this.get_data, imagenext)
          this.get_data = _.orderBy(this.get_data, 'timestamp')
          // console.log(this.get_data)
          this.model_index = _.findIndex(this.get_data, function (o) { return o.tokenmessage === tokenmessage })
          // console.log(this.model_index)
          // console.log(this.get_data)
        } else {
          this.nextArrow = ''
        }
      })
    },
    getimage_frist (inforimage) {
      // console.log(inforimage)
      this.get_data = []
      this.get_data.push(inforimage)
      this.nextArrow = ''
      this.prevArrow = ''
      var imagenext = []
      var imageback = []
      var tokenmessage = inforimage.tokenmessage
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_PUB + '/next_image', { tokenuser: this.tokenuser, tokenroom: this.tokenroom, tokenmessage: inforimage.tokenmessage }).then((response) => {
        // console.log(response.data.data)
        // this.progress = false
        if (response.data.data.length !== 0) {
          this.nextArrow = 'arrow_forward_ios'
          imagenext = response.data.data.reverse()
          // console.log(imagenext)
          // this.get_data.push.apply(this.get_data, imagenext)
        } else {
          this.nextArrow = ''
        }
      })
      this.axios.post(process.env.VUE_APP_API_PUB + '/back_image', { tokenuser: this.tokenuser, tokenroom: this.tokenroom, tokenmessage: inforimage.tokenmessage }).then((response) => {
        // console.log(response.data.data)
        this.progress = false
        if (response.data.data.length !== 0) {
          this.prevArrow = 'arrow_back_ios'
          imageback = response.data.data.reverse()
          // console.log(imageback)
          // console.log(_.union(imageback, this.get_data, imagenext))
          // this.get_data.unshift.apply(this.get_data, imageback)
          this.get_data = _.union(imageback, this.get_data, imagenext)
          this.get_data = _.orderBy(this.get_data, 'timestamp')
          // console.log(this.get_data)
          this.model_index = _.findIndex(this.get_data, function (o) { return o.tokenmessage === tokenmessage })
          // console.log(this.model_index)
        } else {
          this.prevArrow = ''
          this.get_data = _.union(imageback, this.get_data, imagenext)
          this.get_data = _.orderBy(this.get_data, 'timestamp')
          this.model_index = _.findIndex(this.get_data, function (o) { return o.tokenmessage === tokenmessage })
          // console.log(this.model_index)
          this.nicknameSend = this.get_data[this.model_index].nickname
          this.timeSend = this.get_data[this.model_index].timestamp
          this.filenameSend = this.get_data[this.model_index].file_name
          this.pathSend = this.get_data[this.model_index].message
          if (this.get_data[this.model_index].profilepicture === undefined) {
            this.picSend = this.get_data[this.model_index].path_pic
          } else {
            this.picSend = this.get_data[this.model_index].profilepicture
          }
        }
      })
    },
    loadpic () {
      this.loading = true
      this.axios.get(this.pathSend, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.filenameSend)
        document.body.appendChild(link)
        link.click()
        this.loading = false
      })
    },
    close_pic () {
      this.tokenuser = ''
      this.tokenroom = ''
      this.get_data = []
      this.$emit('closeImagedialog', false)
    },
    datethai (timeSend) {
      return Momenttime.momentdatethai(timeSend)
    },
    timethai (timeSend) {
      return Momenttime.momenttimethai(timeSend)
    }
  }
}
</script>
<style scoped>
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-image__image--cover {
  background-size: contain !important;
}
>>>.v-image__image .v-image__image--cover {
  background-position: center center !important;
  background-size: contain !important;
}
>>>.v-carousel__next .v-btn i {
  font-size: 38px !important;
  color: #918f8ff5;
}
>>>.v-carousel__prev .v-btn i {
  margin-left: 60%;
  margin-right: 30%;
  font-size: 38px !important;
  color: #918f8ff5;
}
.buttonsubmit {
  background-color: #ffffffde !important;
  color: green !important;
  width: 105px !important;
  border-radius: 50px !important;
  padding: .75em;
  border: 1px green solid;
  background: linear-gradient(to right, #077629, #077629);
  background-repeat: no-repeat;
  background-size: 0 100%;
  transition: background-size 0.2s 0s;
}
.buttonsubmit:hover {
  background-size: 100% 100%;
  color: white !important;
  border: none !important;
}
.web {
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* padding: 20px; */
  /* font-size: 1.3rem; */
  margin: 0;
  background-color: white;
}
.mobile {
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* padding: 20px; */
  /* font-size: 1.3rem; */
  margin: 0;
  color: white;
}
.CloseIcon {
  position: absolute;
  margin-top: 2%;
  margin-left: 2%;
}
</style>
